




















    import Vue from 'Vue';
    export default Vue.extend({
        name: 'cookie-snackbar',
        props: ['show', 'acceptText','cancelText','text', 'cookieManager'],
        data(): any {
            return { timeout: -1, closed:false }
        },
        computed: {
            showSnackbar(): boolean { return this.show && !this.closed; },
        },
        methods: {
            acceptClicked() {
                this.cookieManager.setConsent();
                this.closed = true;
            },
            cancelClicked() {
                this.cookieManager.removeConsent();
                this.closed = true;
            }
        }
    });
